import React from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { Container } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import { StripeProvider } from 'react-stripe-elements';
import reduxThunk from 'redux-thunk';

import { checkToken } from './components/app/login/actions';
import asyncComponent from './components/util/AsyncComponent';
import auth from './components/util/AuthComponent';
import noAuth from './components/util/NoAuthComponent';
import rootReducer from './reducer.js';

import AppNavbar from './components/app/shared/AppNavbar';
import AppFooter from './components/app/shared/AppFooter';

import './App.css';
import 'react-toastify/dist/ReactToastify.css';

const Login = asyncComponent(() => import('./components/app/login'));
const Register = asyncComponent(() => import('./components/app/register'));
const VerifyEmail = asyncComponent(() =>
  import('./components/app/verify-email')
);
const ForgotPassword = asyncComponent(() =>
  import('./components/app/forgot-password')
);
const ResetPassword = asyncComponent(() =>
  import('./components/app/reset-password')
);
const Dashboard = asyncComponent(() => import('./components/app/dashboard'));
const AccountSetup = asyncComponent(() =>
  import('./components/app/account-setup')
);
const UserAccount = asyncComponent(() =>
  import('./components/app/user-account')
);
const Profile = asyncComponent(() => import('./components/app/profile'));
/*
const Asks = asyncComponent(() => import('./components/app/asks'));
*/
const AddAsk = asyncComponent(() => import('./components/app/asks/add'));
const EditAsk = asyncComponent(() => import('./components/app/asks/edit'));
const Users = asyncComponent(() => import('./components/app/users'));
const EditUser = asyncComponent(() => import('./components/app/users/edit'));
const AddUser = asyncComponent(() => import('./components/app/users/add'));
const DeleteUser = asyncComponent(() =>
  import('./components/app/users/delete')
);
/*
const Partnerships = asyncComponent(() =>
  import('./components/app/partnerships')
);
*/
const ViewPartnership = asyncComponent(() =>
  import('./components/app/partnerships/view')
);
const PartnershipTerms = asyncComponent(() =>
  import('./components/app/partnerships/terms')
);
const BrowseAsks = asyncComponent(() => import('./components/app/browse'));
const ViewAsk = asyncComponent(() => import('./components/app/browse/view'));

const Nonprofits = asyncComponent(() => import('./components/app/nonprofits'));
const ViewNonprofit = asyncComponent(() =>
  import('./components/app/nonprofits/view')
);
const EditNonprofit = asyncComponent(() =>
  import('./components/app/nonprofits/edit')
);

const Corporations = asyncComponent(() =>
  import('./components/app/corporations')
);
const EditCorporation = asyncComponent(() =>
  import('./components/app/corporations/edit')
);
const AddCorporation = asyncComponent(() =>
  import('./components/app/corporations/add')
);
const Settings = asyncComponent(() => import('./components/app/settings'));
const Sponsorships = asyncComponent(() =>
  import('./components/app/sponsorships')
);

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);
const store = createStoreWithMiddleware(rootReducer);

const user = localStorage.getItem('user');
const token = localStorage.getItem('token');

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stripe: null
    };
    if (user && token) {
      checkToken()(store.dispatch);
    }
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({
        stripe: window.Stripe(process.env.REACT_APP_STRIPE_API_KEY)
      });
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({
          stripe: window.Stripe(process.env.REACT_APP_STRIPE_API_KEY)
        });
      });
    }
  }

  render() {
    return (
      <Provider store={store}>
        <StripeProvider stripe={this.state.stripe}>
          <Router>
            <div>
              <AppNavbar />
              <Container fluid>
                <Switch>
                  <Route exact path="/" component={noAuth(Login)} />
                  <Route path="/register" component={noAuth(Register)} />
                  <Route
                    path="/forgot-password"
                    component={noAuth(ForgotPassword)}
                  />
                  <Route
                    path="/reset-password/:token"
                    component={noAuth(ResetPassword)}
                  />
                  <Route path="/verify/:token" component={VerifyEmail} />
                  <Route path="/account-setup" component={auth(AccountSetup)} />
                  <Route path="/dashboard" component={auth(Dashboard)} />
                  <Route path="/account" component={auth(UserAccount)} />
                  <Route path="/profile" component={auth(Profile)} />
                  {/* <Route exact path="/asks" component={auth(Asks)} /> */}
                  <Route exact path="/asks/add" component={auth(AddAsk)} />
                  <Route path="/asks/edit/:id" component={auth(EditAsk)} />
                  <Route exact path="/users" component={auth(Users)} />
                  <Route path="/users/edit/:id" component={auth(EditUser)} />
                  <Route
                    path="/users/delete/:id"
                    component={auth(DeleteUser)}
                  />
                  <Route exact path="/users/add" component={auth(AddUser)} />
                  <Route exact path="/browse" component={auth(BrowseAsks)} />
                  <Route path="/browse/:id" component={auth(ViewAsk)} />
                  {/* <Route
                    exact
                    path="/partnerships"
                    component={auth(Partnerships)}
                  /> */}
                  <Route
                    exact
                    path="/partnerships/terms/:id"
                    component={auth(PartnershipTerms)}
                  />
                  <Route
                    exact
                    path="/partnerships/:id"
                    component={auth(ViewPartnership)}
                  />
                  <Route
                    exact
                    path="/nonprofits"
                    component={auth(Nonprofits)}
                  />
                  <Route
                    exact
                    path="/nonprofits/view/:id"
                    component={auth(ViewNonprofit)}
                  />
                  <Route
                    exact
                    path="/nonprofits/:id"
                    component={auth(EditNonprofit)}
                  />
                  <Route
                    exact
                    path="/corporations"
                    component={auth(Corporations)}
                  />
                  <Route
                    exact
                    path="/corporations/add"
                    component={auth(AddCorporation)}
                  />
                  <Route
                    exact
                    path="/corporations/:id"
                    component={auth(EditCorporation)}
                  />
                  <Route
                    exact
                    path="/sponsorships"
                    component={auth(Sponsorships)}
                  />
                  <Route exact path="/settings" component={auth(Settings)} />
                </Switch>
                <ToastContainer />
              </Container>
              <AppFooter />
            </div>
          </Router>
        </StripeProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js